import React from "react";

export const TriangleDown = () => {
	return (
		<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path opacity="0.4" d="M7 7.5L0.0717989 0.749998L13.9282 0.749999L7 7.5Z" fill="white" />
		</svg>
	);
};
